var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayCircleStory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 21.1458L21.1458 14.5833L10.9375 8.02083V21.1458ZM14.5833 29.1667C12.566 29.1667 10.6701 28.7839 8.89583 28.0182C7.12153 27.2526 5.57812 26.2135 4.26562 24.901C2.95312 23.5885 1.91406 22.0451 1.14844 20.2708C0.382813 18.4965 0 16.6007 0 14.5833C0 12.566 0.382813 10.6701 1.14844 8.89583C1.91406 7.12153 2.95312 5.57812 4.26562 4.26562C5.57812 2.95312 7.12153 1.91406 8.89583 1.14844C10.6701 0.382813 12.566 0 14.5833 0C16.6007 0 18.4965 0.382813 20.2708 1.14844C22.0451 1.91406 23.5885 2.95312 24.901 4.26562C26.2135 5.57812 27.2526 7.12153 28.0182 8.89583C28.7839 10.6701 29.1667 12.566 29.1667 14.5833C29.1667 16.6007 28.7839 18.4965 28.0182 20.2708C27.2526 22.0451 26.2135 23.5885 24.901 24.901C23.5885 26.2135 22.0451 27.2526 20.2708 28.0182C18.4965 28.7839 16.6007 29.1667 14.5833 29.1667Z",
    fill: "#7F5FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleStory);
export default __webpack_public_path__ + "static/media/play_circle_story.719f10a12ea25c5ab4be2b448be38c02.svg";
export { ForwardRef as ReactComponent };